import { Button, Collapse, Typography } from '@material-ui/core';
import { unstable_Box as Box } from '@material-ui/core/Box';
import React, { useState } from 'react';

import i18n from '_utils/i18n';

const DeficiencyBlockAction = ({ deficiency, bookButton }) => {
  const [showDeficiency, setShowDeficiency] = useState(false);

  if (bookButton.props?.disabled) return bookButton;

  return (
    <Box>
      {!showDeficiency && (
        <Button fullWidth color='secondary' variant='outlined' onClick={() => setShowDeficiency(true)}>
          {i18n.t('booking.actions.missing_rentals', { count: deficiency.total })}
        </Button>
      )}
      <Collapse in={showDeficiency}>
        <Typography align='right' component='p' variant='caption'>
          {'Qté indisponible'}
        </Typography>
        <Box mb={1}>
          {deficiency.lines.map((acc, i) => (
            <Box key={i} display='flex' flexDirection='row' alignItems='baseline' justifyContent='space-between'>
              <Typography component='span' variant='caption'>
                {acc.name}
              </Typography>
              <Typography component='span' variant='caption'>
                {`x ${acc.qty}`}
              </Typography>
            </Box>
          ))}
        </Box>
        {bookButton}
      </Collapse>
    </Box>
  );
};

export default DeficiencyBlockAction;
